import { NgxUploaderModule } from '@angular-ex/uploader';
import { CustomerAgentEditorComponent } from './customer-agent-editor/customer-agent-editor';
import { CustomerLookupResolveService } from './shared/services/customer-lookup-resolve.service';
import { CustomerService } from './shared/services/customer.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CustomersRoutingModule } from './customers-routing.module';
import { CustomersShellComponent } from './customers-shell/customers-shell.component';
import { SharedModule } from '../shared/shared.module';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { CustomerBasicComponent } from './customer-basic/customer-basic.component';
import { CustomerDetailsComponent } from './customer-details/customer-details.component';
import { CustomerBillingComponent } from './customer-billing/customer-billing.component';
import { CustomerAgentsComponent } from './customer-agents/customer-agents.component';
import { CustomerViewComponent } from './customer-view/customer-view.component';
import { CustomerEditViewComponent } from './customer-edit-view/customer-edit-view.component';
import { CustomerEditDetailsComponent } from './customer-edit-details/customer-edit-details.component';
import { CustomerEditAgentsComponent } from './customer-edit-agents/customer-edit-agents.component';
import { ColorPickerModule } from 'primeng/colorpicker';
import { TabViewModule } from 'primeng/tabview';
import { AccordionModule } from 'primeng/accordion';
import { CustomerEditBillingComponent } from './customer-edit-billing/customer-edit-billing.component';
import { CustomerEditAgentListComponent } from './customer-edit-agent-list/customer-edit-agent-list.component';
import { CustomerEditContractsAndVerifiedViewComponent } from './customer-edit-contracts-and-verified-view/customer-edit-contracts-and-verified-view.component';
import { CustomerEditVerifiedComponent } from './customer-edit-verified/customer-edit-verified.component';
import { CustomerEditContractsComponent } from './customer-edit-contracts/customer-edit-contracts.component';
import { CustomerLegacyContactsComponent } from './customer-legacy-contacts/customer-legacy-contacts.component';
import { CustomerEventsComponent } from './customer-events/customer-events.component';
import { CustomerAddJobfairComponent } from './customer-add-jobfair/customer-add-jobfair.component';
import { CustomerRequestEventCvDbAccessComponent } from './customer-request-event-cv-db-access/customer-request-event-cv-db-access.component';
import { CustomerEditBrandingComponent } from './customer-edit-branding/customer-edit-branding.component';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { CustomersModerationComponent } from './customers-moderation/customers-moderation.component';
import { CustomerModerationCreateComponent } from './customers-moderation/customer-moderation-create/customer-moderation-create.component';
import { CustomerModerationEditComponent } from './customers-moderation/customer-moderation-edit/customer-moderation-edit.component';
import { MultiSelectModule } from 'primeng/multiselect';
import { DatePicker } from 'primeng/datepicker';
import { CustomerCVBoxChannelsComponent } from './customer-cv-box-channels/customer-cv-box-channels.component';

@NgModule({
  imports: [
    SharedModule,
    CommonModule,
    TabViewModule,
    AccordionModule,
    CustomersRoutingModule,
    NgxUploaderModule,
    ColorPickerModule,
    AngularSvgIconModule,
    MultiSelectModule,
    DatePicker,
  ],
  declarations: [
    CustomersShellComponent,
    CustomerListComponent,
    CustomerBasicComponent,
    CustomerDetailsComponent,
    CustomerBillingComponent,
    CustomerAgentsComponent,
    CustomerViewComponent,
    CustomerEditViewComponent,
    CustomerCVBoxChannelsComponent,
    CustomerEditDetailsComponent,
    CustomerEditAgentsComponent,
    CustomerEditBillingComponent,
    CustomerEditAgentListComponent,
    CustomerAgentEditorComponent,
    CustomerEditContractsAndVerifiedViewComponent,
    CustomerEditVerifiedComponent,
    CustomerEditContractsComponent,
    CustomerLegacyContactsComponent,
    CustomerEventsComponent,
    CustomerAddJobfairComponent,
    CustomerRequestEventCvDbAccessComponent,
    CustomerEditBrandingComponent,
    CustomersModerationComponent,
    CustomerModerationCreateComponent,
    CustomerModerationEditComponent,
  ],
  providers: [CustomerService, CustomerLookupResolveService],
})
export class CustomersModule {}
